import BodySimpleModalV3 from '../../../common/modal/BodySimpleModalV3'
import classes from './LawFirmNotVerified.module.css'

export default function LawFirmNotVerified({lawFirm}) {
    return <>
        {lawFirm && lawFirm.verified == 0 && <BodySimpleModalV3 message={[`Law firm is not verified`]}>
            <div className={classes.not_verified}></div>
        </BodySimpleModalV3>}
    </>
}